// @flow
import React, { PureComponent } from "react"
import ShareIcon from "@kiwicom/orbit-components/lib/icons/Share"
import ButtonLink from "@kiwicom/orbit-components/lib/ButtonLink"

import cuckoo from "common/services/cuckoo/cuckoo"
import type Journey from "common/records/Journey"
import ShareJourneyDialog from "./ShareJourneyDialog"
import { cuckooEvents } from "common/consts/enums"

type Props = {|
  journey: Journey,
  detached: boolean,
  url: string,
  fixed?: boolean,
|}

type State = {|
  dialogOpened: boolean,
|}

class JourneyShare extends PureComponent<Props, State> {
  state = {
    dialogOpened: false,
  }

  handleCloseDialog = () => {
    this.setState({ dialogOpened: false })
  }

  handleToggleDialog = (e: SyntheticEvent<*>) => {
    e.stopPropagation()
    e.preventDefault()
    const { dialogOpened } = this.state
    const { url } = this.props
    if (!dialogOpened) {
      cuckoo.infinario("shareFlight", { action: "clickOnShare" })
    }
    cuckoo.track(cuckooEvents.SHARE_ACTION_CLICK, { url })
    this.setState({ dialogOpened: !dialogOpened })
  }

  updateDialogPosition = (dialogRef: *) => {
    const iconEl = this.iconRef.current
    const dialogEl = dialogRef.current

    if (iconEl && dialogEl) {
      const coords = iconEl.getBoundingClientRect()

      dialogEl.setAttribute(
        "style",
        `top:${coords.top + coords.height / 2}px;left:${coords.left}px`,
      )
    }
  }

  iconRef: { current: React$ElementRef<any> } = React.createRef()

  render() {
    const { journey, detached, url, fixed } = this.props
    const { dialogOpened } = this.state

    return (
      <>
        <ButtonLink
          ref={this.iconRef}
          onClick={this.handleToggleDialog}
          iconLeft={<ShareIcon />}
          type="secondary"
        />
        {dialogOpened && (
          <ShareJourneyDialog
            journey={journey}
            onToggle={this.handleToggleDialog}
            onClose={this.handleCloseDialog}
            updatePosition={this.updateDialogPosition}
            detached={detached}
            url={url}
            fixed={fixed}
          />
        )}
      </>
    )
  }
}

export default JourneyShare
